import { Component, Input, OnInit } from '@angular/core';
import { ApiFlowSection } from 'src/app/model/section/api-flow-section';
import { RibbonTileSection } from 'src/app/model/section/ribbon-tile-section';

@Component({
  selector: 'app-api-reference-ribbon-tile-section',
  templateUrl: './api-reference-ribbon-tile-section.component.html',
  styleUrls: ['./api-reference-ribbon-tile-section.component.scss']
})
export class ApiReferenceRibbonTileSectionComponent implements OnInit {
  @Input() ribbonTileSections: RibbonTileSection[] = [];
  @Input() isPaymentsPage: boolean = false;
  @Input() isSeatAvailabilityOverviewPage: boolean = false;
  @Input() isRibbonTile: boolean = false;
  @Input() isRibbonTileSawToothVertical: boolean = false;

  constructor() {}

  ngOnInit(): void {}
}
